import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../theme';
import { NASStatus } from '@websky/graphql';
import { initI18n } from '../../utils';
import Tabs from '../../Tabs/Tabs';
import FlightInfoCardTabs from './FlightInfoCardTabs/FlightInfoCardTabs';
import FlightInfoCardHeader from './FlightInfoCardHeader/FlightInfoCardHeader';
import Sticky from './Sticky/Sticky';
import { useToggleable } from '../../hooks';
import TicketsModal from './TicketsModal/TicketsModal';
initI18n('FlightInfoCard');
const FlightInfoCard = ({ segmentId, setSegmentId, order, onPassengerDetails, onDownloadTickets, className }) => {
    var _a;
    const { FlightInfoCard: css } = useTheme('FlightInfoCard');
    const { isOpen: isDownloadOpen, open: downloadOpen, close: downloadClose } = useToggleable(false);
    const tabs = order.flight.segments.map(segment => {
        return {
            header: `${segment.segment.departure.airport.city.name} — ${segment.segment.arrival.airport.city.name}`,
            value: +segment.segment.id
        };
    });
    const everyPortPassengerIds = React.useMemo(() => {
        var _a, _b, _c;
        const passengerIds = [];
        (_c = (_b = (_a = order === null || order === void 0 ? void 0 : order.additionalServices) === null || _a === void 0 ? void 0 : _a.nas) === null || _b === void 0 ? void 0 : _b.selectedServices) === null || _c === void 0 ? void 0 : _c.forEach(service => {
            if (service.status === NASStatus.Confirmed) {
                service.travellers.forEach(traveller => {
                    passengerIds.push(traveller.id);
                });
            }
        });
        return passengerIds;
    }, [order]);
    return (React.createElement("div", { className: cn(css.wrapper, className) },
        React.createElement(FlightInfoCardHeader, { order: order, onPassengerDetails: onPassengerDetails, onDownloadTickets: downloadOpen }),
        React.createElement(Sticky, { stickyClassName: css.stickyTabs },
            React.createElement(Tabs, { tabs: tabs, selected: +segmentId, onChange: setSegmentId, selectedTabClassName: css.tabs__selectedTab, className: css.tabs__container, tabClassName: css.tabs__tab, tabLabelClassName: css.tabs__tab__label, tabHeaderClassName: css.tabs__tab__header, flexContainerClassName: css.flexTabsContainer, variant: "scrollable" })),
        React.createElement(FlightInfoCardTabs, { flight: order.flight, segmentId: segmentId, onChangeIndex: setSegmentId, orderId: order.id }),
        React.createElement(TicketsModal, { open: isDownloadOpen, onClose: downloadClose, everyPortPassengerIds: everyPortPassengerIds, withEveryTravelServices: !!((_a = order.price) === null || _a === void 0 ? void 0 : _a.everyTravel) })));
};
export default FlightInfoCard;
